module.exports = __webpack_public_path__ + "img/visa-pay.d15d4998.svg";